import { Link, Typography } from "@mui/material";
import { Submission } from "generated-graphql/graphql";

type SubmissionAlertProps = {
  submission: Pick<Submission, "id" | "tenantId">;
  message: string;
  title: string;
  includeViewSubmissionLink: boolean;
};

export function SubmissionAlert({
  submission,
  message,
  title,
  includeViewSubmissionLink = true,
}: SubmissionAlertProps) {
  return (
    <>
      <Typography variant="body1" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2">
        {message}{" "}
        {includeViewSubmissionLink && (
          <Link href={`submissions/${submission.id}`} sx={{ color: "#1E4620" }}>
            View submission
          </Link>
        )}
      </Typography>
    </>
  );
}
